// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__7mpiH","socials":"Footer_socials__I4PqK","span":"Footer_span__kYbJ3","lightFooter":"Footer_lightFooter__CGvmw","darkFooter":"Footer_darkFooter__GgBW4"};